import { Controller } from "@hotwired/stimulus"
import { showAlert } from "../lib/alerts"

// Handles adding a plant to a user's list via select dropdown
// Values: username, plantId
// Targets: select
export default class extends Controller {
  static values = { username: String, plantId: Number }
  static targets = ["select"]

  change(event) {
    const slug = event.target.value
    if (slug === "") return

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`/${this.usernameValue}/${slug}/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ list: { plant_id: this.plantIdValue } })
    }).then(response => {
      if (response.ok) {
        showAlert("Added plant to list")
        event.target.value = ""
      }
    })
  }
}
